import axios from "axios";
import api from "./api";

/** Apply a token to this tab's in-memory clients without rewriting shared storage. */
export const applyAuthToken = (token) => {
    if (token) {
        api.defaults.headers.common["x-auth-token"] = token;
        api.defaults.headers.common["Authorization"] = "Bearer " + token;
        axios.defaults.headers.common["x-auth-token"] = token;
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    }
};

const setAuthToken = (token) => {
    if (token) {
        applyAuthToken(token);

        // A browser can deny localStorage (for example in privacy-restricted contexts).
        // Authentication has already succeeded at this point, so failure to persist the
        // client token must not abort the redirect and be reported as invalid credentials.
        try {
            // Replace atomically. removeItem()+setItem() briefly looked like a logout to
            // every other tab and caused unnecessary navigation churn.
            localStorage.setItem("token_" + window.bo_site, token);
        } catch (e) {}
    }
};

/**
 * Drop the stored access token AND the pinned request headers.
 *
 * Clearing localStorage alone is not enough: the axios defaults are pinned once at boot, so a
 * dead token keeps riding along on every later request. On routes that verify a presented token
 * (jwt.optional) that means an endless 401 loop instead of falling back to the guest response.
 */
export const clearAuthToken = () => {
    try {
        localStorage.removeItem("token_" + window.bo_site);
    } catch (e) {}

    delete api.defaults.headers.common["x-auth-token"];
    delete api.defaults.headers.common["Authorization"];
    if (window.axios) {
        delete window.axios.defaults.headers.common["x-auth-token"];
        delete window.axios.defaults.headers.common["Authorization"];
    }
};

export default setAuthToken;
